// paypal-button.component.ts
import { Component, AfterViewInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
declare var paypal: any;
@Component({
  selector: 'app-paypal-button',
  template: `<div id="paypal-button-container"></div>`
})

export class PaypalComponent implements AfterViewInit {
  @Input() amount: number = 10; // USD
  clientID: string = 'AaESz8R9PhEdryZ0E5lqglMCEtsWL3PnJZm5ifsqAepYUKZNYmGAZ6b9_4LApTqTtZ3RfTmIDVbPqgRs';
/**
 * Constructor for the class
 * @param http - HttpClient instance for making HTTP requests
 * This is a dependency injection of HttpClient service
 */
  constructor(private http: HttpClient) { }

  ngAfterViewInit(): void {
    this.loadPaypalSdk(this.clientID).then(() => {
      this.renderPaypalButton();
    }).catch(err => console.error('Failed to load PayPal SDK', err));
  }

  private loadPaypalSdk(clientID: string): Promise<void> {
    return new Promise((resolve, reject) => {
      // Check if script already exists
      if (document.getElementById('paypal-sdk')) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.id = 'paypal-sdk';
      script.src = `https://www.paypal.com/sdk/js?client-id=${clientID}&components=buttons&currency=USD`;
      script.onload = () => resolve();
      script.onerror = (err) => reject(err);
      document.body.appendChild(script);
    });
  }

  private renderPaypalButton() {
    paypal.Buttons({
      style: {
        layout: 'vertical',
        color: 'black',
        shape: 'rect',
        label: 'pay',
      },
      fundingSource: paypal.FUNDING.CARD,
      createOrder: (data: any, actions: any) => {
        return this.http.post<any>(
          'https://collabtic-pre-prod-v3api.collabtic.com/v1/market-place/createorder',
          {}
        ).toPromise()
          .then(res => res.id);
      },
      onApprove: (data: any, actions: any) => {
        return this.http.post<any>(
          `https://collabtic-pre-prod-v3api.collabtic.com/v1/market-place/captureorder?orderId=${data.orderID}`,
          {}
        ).toPromise()
          .then(res => {
            alert('Payment Successful!');
            console.log(res);
          })
          .catch(err => {
            if (err.details?.[0]?.issue === 'INSTRUMENT_DECLINED') {
              // let user try again
              // @ts-ignore
              actions.restart();
            } else {
              alert('Payment failed!');
            }
          });
      },
      onError: (err: any) => {
        console.error(err);
        alert('Payment failed!');
      }
    }).render('#paypal-button-container');
  }
}
